function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".contact_svg__cls-1{fill:none;stroke:#000;stroke-linejoin:round;stroke-width:.25px}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "contact_svg__cls-1",
  d: "M9.405 4.712V.147H.147v6.307h1.46V8.83l2.565-2.376h.134"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "contact_svg__cls-1",
  d: "M11.553 5.424v4.452h-1.03v1.677L8.711 9.876H5.018V5.424h6.535z"
});

function SvgContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "contact_svg__Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.7 11.7"
  }, props), _ref, _ref2, _ref3);
}

export default SvgContact;